import { z } from 'zod';

/** Customer management grants supplement, and never replace, plan permissions. */
export const CUSTOMER_SERVICE_PERMISSIONS = ['mail', 'dns', 'files', 'databases', 'websites', 'tasks', 'services', 'monitoring'] as const;
export type CustomerServicePermission = (typeof CUSTOMER_SERVICE_PERMISSIONS)[number];
export const CUSTOMER_SERVICE_PERMISSION_LABELS: Record<CustomerServicePermission, string> = {
  mail: 'Mail accounts and preferences', dns: 'DNS records', files: 'File accounts',
  databases: 'Databases', websites: 'Website settings', tasks: 'Scheduled tasks',
  services: 'Installed services', monitoring: 'Monitoring checks',
};
export const customerServicePermissionsSchema = z.array(z.enum(CUSTOMER_SERVICE_PERMISSIONS))
  .max(CUSTOMER_SERVICE_PERMISSIONS.length)
  .refine((values) => new Set(values).size === values.length, 'Choose each permission only once');

export function canManageCustomerService(
  user: { role?: string; accountAdmin: boolean; servicePermissions?: readonly CustomerServicePermission[] } | null | undefined,
  permission: CustomerServicePermission,
): boolean {
  return !!user && (user.role === undefined || user.role === 'client') &&
    (user.accountAdmin || user.servicePermissions?.includes(permission) === true);
}
